/*
 * Copyright (c) Worldline 2023.
 */

export const CookieAgreementStatus = {
    AGREED: 'AGREED',
    REFUSED: 'REFUSED'
}